import { SECRET_ENCRYPTION_KEY } from "./ServerConstants";
import CryptoJS from "crypto-js";
import { get } from "lodash";

export const decryptBankingData = (text: string | number) => {
  if (!text || !SECRET_ENCRYPTION_KEY) return text;
  const decryptedData = CryptoJS.AES.decrypt(
    text.toString(),
    SECRET_ENCRYPTION_KEY
  ).toString(CryptoJS.enc.Utf8);
  return JSON.parse(JSON.stringify(decryptedData));
};

export const formatCurrency = (
  value: number,
  locale = "en-US",
  currency = "USD"
): string => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);
};

export const maskValue = (value: string | null | undefined, maxLength?: number): string => {
  if (!value) return "N/A";
  if (value.length <= 3) return value;
  const lastThree = value.slice(-3);
  const totalLength = maxLength && value.length > maxLength ? maxLength : value.length;
  const maskedPart = "*".repeat(Math.max(0, totalLength - 3));
  return `${maskedPart}${lastThree}`;
};

export const getUserDisplayName = (user: any): string => {
  const fullname = get(user, "fullname");
  if (typeof fullname === "string" && fullname.trim()) return fullname.trim();
  const firstName = get(user, "first_name") || "";
  const lastName = get(user, "last_name") || "";
  return `${firstName} ${lastName}`.trim();
};

export const isValidUrl =(url: string): boolean => {
  try {
    url = url.trim()
    if (/\s/.test(url)) return false;

    const VALID_TLDS = new Set([
      "com", "org", "net", "gov", "edu", "io", "co", "uk", "co.uk", "dev", "ai",
      "in", "us", "ca", "de", "jp", "fr", "au", "info", "biz", "xyz", "me", "tv"
    ]);

    const parsedUrl = new URL(url.trim());

    // Must use http or https
    if (!/^https?:$/.test(parsedUrl.protocol)) return false;

    const hostname = parsedUrl.hostname;

    // Must contain at least one dot
    if (!hostname.includes('.')) return false;

    const parts = hostname.split('.');
    if (parts.length < 2) return false;

    // Get last one or two parts to match TLDs like "co.uk"
    const tld = parts.slice(-2).join('.').toLowerCase();
    const simpleTld = parts.slice(-1)[0].toLowerCase();

    if (!VALID_TLDS.has(tld) && !VALID_TLDS.has(simpleTld)) {
      return false;
    }

    return true;
  } catch (e) {
    return false;
  }
};

export const randomKeyString = (length: number, characters: string) => {
  const charactersLength = characters.length;
  return Array.from({ length }, () =>
    characters.charAt(Math.floor(Math.random() * charactersLength)) // NOSONAR
  ).join("");
};

export const generateKeys = () => {
  const hexChars = "abcdef0123456789";
  const secureChars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";

  return {
    xApiKey: randomKeyString(64, hexChars),
    secretKey: randomKeyString(32, secureChars),
  };
};
